import { BadgeCheck, Sparkles, Star, type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface ProviderStatusBadgesProps {
  isFeatured?: boolean;
  isTopRated?: boolean;
  isVerified?: boolean;
  className?: string;
  badgeClassName?: string;
}

interface BadgeDefinition {
  key: string;
  label: string;
  icon: LucideIcon;
  visible: boolean;
  textClassName: string;
}

const ProviderStatusBadges = ({
  isFeatured = false,
  isTopRated = false,
  isVerified = false,
  className,
  badgeClassName,
}: ProviderStatusBadgesProps) => {
  const badges: BadgeDefinition[] = [
    {
      key: "featured",
      label: "Featured",
      icon: Sparkles,
      visible: isFeatured,
      textClassName: "text-plum",
    },
    {
      key: "top-rated",
      label: "Top Rated",
      icon: Star,
      visible: isTopRated,
      textClassName: "text-amber",
    },
    {
      key: "verified",
      label: "Verified",
      icon: BadgeCheck,
      visible: isVerified,
      textClassName: "text-teal",
    },
  ].filter((badge) => badge.visible);

  if (badges.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-col items-start gap-1.5", className)}>
      {badges.map(({ key, label, icon: Icon, textClassName }) => (
        <span
          key={key}
          className={cn(
            "inline-flex items-center gap-1 rounded-md bg-white/90 px-2 py-0.5 text-xs font-medium shadow-sm backdrop-blur-sm",
            textClassName,
            badgeClassName,
          )}
        >
          <Icon className="h-3 w-3" />
          {label}
        </span>
      ))}
    </div>
  );
};

export default ProviderStatusBadges;